import { render, staticRenderFns } from "./ListStudentResult.vue?vue&type=template&id=9137ae56&scoped=true"
import script from "./ListStudentResult.vue?vue&type=script&lang=js"
export * from "./ListStudentResult.vue?vue&type=script&lang=js"
import style0 from "./ListStudentResult.vue?vue&type=style&index=0&id=9137ae56&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9137ae56",
  null
  
)

export default component.exports